import { createFileRoute, useSearch } from '@tanstack/react-router'
import { z } from 'zod'
import { CreateAccountScreen } from '@/features/auth/routes/create-account-screen'

// The token rides in the query string, not the path, so page-view analytics
// (which record the path only) never see it.
const searchSchema = z.object({ token: z.string().optional() })

export const Route = createFileRoute('/create-account')({
  validateSearch: searchSchema,
  component: CreateAccountRoute,
})

function CreateAccountRoute() {
  const { token } = useSearch({ from: '/create-account' })
  return <CreateAccountScreen token={token ?? null} />
}
